var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.032,2.09l3.042,9.4h9.882l-7.992,5.8,3.042,9.4-7.992-5.814L5.022,26.678l3.06-9.4L.09,11.468l9.882.018,3.06-9.4Zm4.932,15.192-4.932,3.582,5.616-1.458Z","transform":"translate(-0.09 -2.09)","fill":"currentColor"}));
}

Star.defaultProps = {"className":"svg-icon svg-icon--TrustpilotStar","width":"20","height":"19","viewBox":"0 0 25.866 24.588"};

module.exports = Star;

Star.default = Star;
